import * as React from "react";
import useWindowSize from "../../../../../hooks/useWindowSize";
import { func } from "../../../../../utils";

export interface MatchProps {
  goals: number;
  penaltyGoals: number;
  fouls: number;
  yellowCard: number;
  redCard: number;
}

export interface itemProps {
  home_value: string;
  away_value: string;
  title: string;
  dominating: "home" | "away" | "draw";
  noBorder?: boolean;
}

const Item: React.FC<itemProps> = ({
  home_value,
  away_value,
  title,
  dominating,
  noBorder = false,
}) => {
  return (
    <div
      style={!noBorder ? { borderBottom: "1px solid #F0F2F9" } : {}}
      className="flex justify-between p-[16px] gap-[16px]"
    >
      <p
        style={dominating === "home" ? { backgroundColor: "#77B341", fontWeight: "bold" } : {}}
        className="text-[13px] leading-[20px] pt-[2px] px-[8px] rounded-[16px]  text-white"
      >
        {home_value || 0}
      </p>
      <p className="text-[14px] leading-[19px] font-bold text-white">{title}</p>
      <p
        style={dominating === "away" ? { backgroundColor: "#77B341", fontWeight: "bold" } : {}}
        className="text-[13px] leading-[20px] pt-[2px] px-[8px] rounded-[16px]  text-white"
      >
        {away_value || 0}
      </p>
    </div>
  );
};

export interface MatchDetailProps {
  home: MatchProps;
  away: MatchProps;
}

const MatchDetail: React.FC<MatchDetailProps> = ({ home, away }) => {
  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;

  const generateDominatingTeam = (home_value: number, away_value: number) => {
    if (home_value > away_value) return "home";
    if (home_value < away_value) return "away";

    return "draw";
  };

  const containerClassname = isMobileView ? "" : "p-[32px] rounded-[24px] mt-[24px] mb-[60px]";

  return (
    <React.Fragment>
      <div
        style={
          isMobileView
            ? {
                zIndex: 1,
              }
            : { border: "1px solid #6A7481", zIndex: 1 }
        }
        className={containerClassname}
      >
        <Item
          home_value={
            String(home?.goals) + String(home?.penaltyGoals ? ` (${home?.penaltyGoals})` : "")
          }
          away_value={
            String(away?.goals) + String(away?.penaltyGoals ? ` (${away?.penaltyGoals})` : "")
          }
          dominating={generateDominatingTeam(
            home?.goals + home?.penaltyGoals,
            away?.goals + away?.penaltyGoals,
          )}
          title="Goals"
        />
        <Item
          home_value={String(home?.fouls)}
          away_value={String(away?.fouls)}
          dominating={generateDominatingTeam(home?.fouls, away?.fouls)}
          title="Fouls"
        />
        <Item
          home_value={String(home?.yellowCard)}
          away_value={String(away?.yellowCard)}
          dominating={generateDominatingTeam(home?.yellowCard, away?.yellowCard)}
          title="Yellow Cards"
        />
        <Item
          home_value={String(home?.redCard)}
          away_value={String(away?.redCard)}
          dominating={generateDominatingTeam(home?.redCard, away?.redCard)}
          title="Red Cards"
          noBorder
        />

        {isMobileView && <div className="mb-[40px]" />}
      </div>
    </React.Fragment>
  );
};

export default MatchDetail;
